module.exports = "<span ng-if=\"::$ctrl.tag\" class=\"deliverySaverPlanTag\" style=\"{{ ::$ctrl.tag.Style }}\">{{ ::$ctrl.tag.Value }}</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/deliverysaver/plantag/delivery-saver-plan-tag.component.html
// module id = 392
// module chunks = 0 9